module.exports = __webpack_public_path__ + "img/w3_circle_in_stock_grey.ebd39888.png";